import React, { useEffect } from 'react'
import store from '../store'
import { Provider } from 'react-redux'

import { ContainerParent } from '../models/enums'
import type { RetorikMainComponentProps } from '../models/retorikTypes'

import { TelemetryProvider } from './Contexts/TelemetryContext'
import ErrorCollector from './Telemetry/ErrorCollector'
import GlobalProvider from './Contexts/GlobalProvider'
import ShadowRoot from './Common/ShadowRoot'
import RetorikConfigHandler from './Common/RetorikConfigHandler'

const RetorikAgent = (props: RetorikMainComponentProps): JSX.Element => {
  // --------- /!\ -----------
  // Ne mettre ici que de la logique spécifique au retorikAgent
  // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer
  // -------------------------

  useEffect(() => {
    props.renderCallback?.()
  }, [])

  return (
    <Provider store={store}>
      <TelemetryProvider>
        <GlobalProvider instanceId={props.instanceId}>
          <ShadowRoot>
            <ErrorCollector>
              <RetorikConfigHandler {...{ parent: ContainerParent.agent, ...props }} />
            </ErrorCollector>
          </ShadowRoot>
        </GlobalProvider>
      </TelemetryProvider>
    </Provider>
  )
}

export default RetorikAgent
